import { KnowWhyInvestment } from '../../../components/know-why/KnowWhyInvestment'
import { PowerPerformanceForms } from '../../../types/mutual-fund-detail.types'
import type { FundInfo } from '../types'

interface RegularPlanFundCardProps {
  fund: FundInfo
}

export function RegularPlanFundCard({ fund }: RegularPlanFundCardProps) {
  const logoSrc = fund?.logoUrl ?? ''
  const title = fund?.name ?? ''
  const fundType = fund?.nature ?? ''
  const fundCategory = fund?.category ?? ''

  return (
    <div className="text-[#6A6E6E] text-[14px] font-[400] leading-[150%] w-full">
      <KnowWhyInvestment
        logoSrc={logoSrc}
        title={title}
        fundType={fundType}
        fundCategory={fundCategory}
        powerForm={null}
        isRegular={true}
      />
    </div>
  )
}
